export default function Divider() {
    return (
        <>
            <hr className="janus-biz-divider left"></hr>
            <hr className="janus-biz-divider right"></hr>
            <img alt="Janus.biz logo" className="janus-biz-divider-icon" src='janus-biz-logo.png' />
        </>
    )
}